import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';
import axios, { AxiosError, Method } from 'axios';
import { ActionTypes, ApiAction, HttpMethods } from '../../../TCSMApp/global/models/api-model';
import { apiError } from '../../../TCSMApp/global/ducks/base-api';
import { BaseAppState } from '../models/redux-state';

export const apiMiddleware = ({ dispatch, getState }: MiddlewareAPI<any>) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {

	if (action.type !== ActionTypes.API) {
		return next(action);
	}

	const { url, method, payloadData, onStart, onEnd, onSuccess, onFailure, formData, contentType, mockApi, mockApiHandler } = (action as ApiAction).payload;

	if (mockApi && mockApiHandler) {
		mockApiHandler?.handleApiCall({ onStart, onSuccess, onFailure, onEnd });
		return next(action);
	}

	const dataOrParams = (method === HttpMethods.GET) ? 'params' : 'data';

	const accessToken = (getState() as BaseAppState)?.authenticatedState?.accessToken;	
	
	const headers: any = {		
		'Content-Type': contentType,
		'Accept': '*/*',		
	};	

	if (accessToken){
		headers.Authorization = `Bearer ${accessToken}`;
	}

	dispatch(onStart());

	axios.defaults.headers = {
		'Cache-Control': 'no-cache',
		'Expires': '0',
	};
	axios.request({
		url,
		method: method as Method,
		headers,
		[dataOrParams]: payloadData || formData,
	})
		.then(({ data }) => {
			onSuccess(data);
		})
		.catch((error: AxiosError) => {

			dispatch(apiError(error, url, method, headers)); // handled in api error reducer
			onFailure();
		})
		.finally(() => {
			dispatch(onEnd());
		});

	return next(action);
};